// extracted by mini-css-extract-plugin
export default {"container":"V_nmEhHH85rVZC1XVAhe","headerBar":"x31ZJRa_8vRiYpcLQnQA","header":"ByLIKtNAUQolVLuT9yJu","trash":"YsPJF1qwwuhAUUGSKsg1","content":"NgngDp9BkaBZ5Pdjj6tT"};